module.exports = {
  // Page title and toolbar
  title: 'Visual Editor',
  titleWithName: 'Visual Editor: {name}',
  untitled: 'Untitled',

  // Toolbar buttons
  cancel: 'Cancel',
  saveAndClose: 'Save & Close',

  // Loading and status messages
  initializingEditor: 'Initializing editor...',
  searching: 'Searching...',
  editorTimeout: 'Editor initialization timed out',
  editorTimeoutMessage: 'The visual editor failed to load. Please try again or refresh the page.',

  // Error messages
  noSessionId: 'No session ID provided. Please close this window and try again.',
  browserNotSupported: 'Your browser does not support the visual editor. Please upgrade to a modern browser.',
  editorContainerNotFound: 'Editor container not found. Please refresh the page.',
  failedToInitialize: 'Failed to initialize editor: {error}',
  failedToLoad: 'Failed to load editor data: {error}',
  failedToSave: 'Failed to save editor data: {error}',
  noAuthToken: 'No auth token available - translation search disabled',
  unauthorizedToken: 'Unauthorized: Invalid or expired auth token',

  // Parent page messages (ScreenDetails.vue)
  popupBlocked: 'Popup blocked! Please allow popups for this site and try again.',
  editorFailedToInitialize: 'Visual editor failed to initialize. Please try again or refresh the page.',
  editorConnectionLost: 'Visual editor connection lost. The editor tab may have been closed.',
  editorCancelled: 'Visual editing cancelled',
  designImported: 'Screen design imported from visual editor',
  failedToImport: 'Failed to import editor data: {error}',
  failedToOpen: 'Failed to open visual editor: {error}',
  confirmLeave: 'The visual editor is still open. Do you want to close the editor and leave this page?',

  // Console/debug messages (not shown to users but good to have translated)
  noInitData: 'No init data received, starting with empty project',
  noComponentSelected: 'No component selected',

  // GrapesJS plugin labels
  importTemplate: 'Import Template',
  importTemplateLabel: 'Paste here your HTML/CSS and click Import',
  categoryExtra: 'Extra',

  // Typed plugin default strings
  typedTextRow1: 'Text row one',
  typedTextRow2: 'Text row two',
  typedTextRow3: 'Text row three',

  // Trait labels and placeholders
  traitId: 'ID',
  traitTranslation: 'Translation',
  traitText: 'Text',
  placeholderTextContent: 'Enter text content',
  placeholderLinkText: 'Link text',
  placeholderSearchTranslations: 'Search translations (min 3 chars)...',
  noTranslationsFound: 'No translations found'
}